/**
 * Avatar Component
 * Generates initials for avatars without images
 */

/**
 * Generate initials from a name
 * @param {string} name - Full name
 * @returns {string} Initials (1-2 characters)
 */
function generateInitials(name) {
  if (!name || typeof name !== 'string') return '?';

  const trimmed = name.trim();
  if (!trimmed) return '?';

  const words = trimmed.split(/\s+/).filter(word => word.length > 0);

  if (words.length === 0) return '?';
  if (words.length === 1) return words[0][0].toUpperCase();

  // Take first letter of first and last word
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

/**
 * Initialize avatar components
 * - Generates initials for avatars without images
 */
export function initAvatar(container = document) {
  const avatars = container.querySelectorAll('.avatar[data-name]');

  avatars.forEach(avatar => {
    // Skip if already initialized
    if (avatar.dataset.avatarInitialized) return;
    avatar.dataset.avatarInitialized = 'true';

    const name = avatar.dataset.name;
    const hasImage = avatar.querySelector('.avatar__img');

    // Only generate initials if no image is present
    if (!hasImage) {
      const initials = generateInitials(name);

      // Create initials element if it doesn't exist
      let initialsEl = avatar.querySelector('.avatar__initials');
      if (!initialsEl) {
        initialsEl = document.createElement('span');
        initialsEl.className = 'avatar__initials';
        avatar.appendChild(initialsEl);
      }

      initialsEl.textContent = initials;
    }
  });
}
